<template>
  <div class="error-page">
      <div class="error-box">
        <div class="error-logo">
          <router-link to="/home/">
            <img src="@/assets/img/caduceus.png" class="img-fluid" alt="Logo" />
          </router-link>
        </div>
        <div class="error-box-img">
          <img src="@/assets/img/error-01.png" alt="" class="img-fluid" />
        </div>
        <h3 class="h2 mb-3">Ahh não! Erro 404</h3>
        <p class="h4 font-weight-normal">
          Página não encontrada
        </p>
        <router-link to="/home/" class="btn btn-primary">Página Inicial</router-link>
      </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>
